import { connect } from 'react-redux';
import FeatureReport from '../../../features/featureReport/shared/FeatureReport';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => ({
    performanceTables: selectors.getPerformanceTables(state),
    totalStudentCount: selectors.getTotalNumberOfStudents(state),
    infoSummary: selectors.getSummaryInfoData(state),
    toyPeriods: selectors.getToyPeriods(state),
    summerPeriodLabel: selectors.getSummerPeriodLabel(state),
});

export default connect(mapStateToProps, {})(FeatureReport);
